export interface Robe {
  key: string
  text: string
  active: boolean
  priority: number
}

const robes: Robe[] = [
  { key: 'BL', text: 'BLANC', priority: 0, active: true },
  { key: 'BOB', text: 'BAI OU BAI BRUN', priority: 0, active: true },
  { key: 'BBA', text: 'BAI BRUN OU ALEZAN BRULE', priority: 0, active: true },
  { key: 'BZ', text: 'BAI ZAIN', priority: 0, active: true },
  { key: 'BR', text: 'BAI RUBICAN', priority: 0, active: true },
  { key: 'BC', text: 'BAI CLAIR', priority: 0, active: true },
  { key: 'BBG', text: 'BAI BRUN OU GRIS', priority: 0, active: true },
  { key: 'BBF', text: 'BAI BRUN FONCE', priority: 6, active: true },
  { key: 'BB', text: 'BAI BRUN', priority: 0, active: true },
  { key: 'BF', text: 'BAI FONCE', priority: 0, active: true },
  { key: 'B', text: 'BAI', priority: 7, active: true },
  { key: 'AUG', text: 'AUBERE OU GRIS', priority: 0, active: true },
  { key: 'AUB', text: 'AUBERE', priority: 0, active: true },
  { key: 'AC', text: 'ALEZAN CUIVRE', priority: 0, active: true },
  { key: 'AZ', text: 'ALEZAN ZAIN', priority: 0, active: true },
  { key: 'AOG', text: 'ALEZAN OU GRIS', priority: 0, active: true },
  { key: 'AAU', text: 'ALEZAN AUBERISE', priority: 0, active: true },
  { key: 'AF', text: 'ALEZAN FONCE', priority: 0, active: true },
  { key: 'AR', text: 'ALEZAN RUBICAN', priority: 0, active: true },
  { key: 'ACL', text: 'ALEZAN CRINS LAVES', priority: 0, active: true },
  { key: 'AB', text: 'ALEZAN BRULE', priority: 0, active: true },
  { key: 'AL', text: 'ALEZAN', priority: 5, active: true },
  { key: 'BGR', text: 'BAI OU GRIS', priority: 0, active: false },
  { key: 'NPAMEL', text: 'NOIR PANGARE MELANGE', priority: 0, active: true },
  { key: 'NOITAC', text: 'NOIR TACHETE', priority: 0, active: true },
  { key: 'ISACAP', text: 'ISABELLE CAPE', priority: 0, active: true },
  { key: 'GR CL', text: 'GRIS CLAIR', priority: 0, active: true },
  { key: 'CRETAC', text: 'CREME TACHETE', priority: 0, active: true },
  { key: 'CREPIE', text: 'CREME PIE', priority: 0, active: true },
  { key: 'CHOCO', text: 'CHOCOLAT', priority: 0, active: true },
  { key: 'BAICRL', text: 'BAI CRINS LAVES', priority: 0, active: true },
  { key: 'BCE', text: 'BAI CERISE', priority: 0, active: true },
  { key: 'BM', text: 'BAI MELANGE', priority: 0, active: true },
  { key: 'AL.M', text: 'ALEZAN MELANGE', priority: 0, active: true },
  { key: 'ALB', text: 'ALEZAN BRUN', priority: 0, active: true },
  { key: 'NME', text: 'NOIR MELANGE', priority: 0, active: true },
  { key: 'NP', text: 'NOIR PANGARE', priority: 0, active: true },
  { key: 'API', text: 'ALEZAN PIE', priority: 0, active: true },
  { key: 'CRM', text: 'CREME', priority: 0, active: true },
  { key: 'BPI', text: 'BAI PIE', priority: 0, active: true },
  { key: 'xx', text: 'Inconnue', priority: 2, active: true },
  { key: 'BBR', text: 'BAI BRUN RUBICAN', priority: 0, active: true },
  { key: 'BRO', text: 'BAI ROUANNE', priority: 0, active: true },
  { key: 'BA', text: 'BAI AUBERISE', priority: 0, active: true },
  { key: 'SO', text: 'SOURIS', priority: 0, active: true },
  { key: 'RO', text: 'ROUAN', priority: 0, active: true },
  { key: 'PB', text: 'PIE BAI', priority: 0, active: true },
  { key: 'PG', text: 'PIE GRIS', priority: 0, active: true },
  { key: 'PN', text: 'PIE NOIR', priority: 0, active: true },
  { key: 'PR', text: 'PIE ROUAN', priority: 0, active: true },
  { key: 'PA', text: 'PIE ALEZAN', priority: 0, active: true },
  { key: 'P', text: 'PIE', priority: 0, active: true },
  { key: 'NM', text: 'NOIR MALTEINT', priority: 0, active: true },
  { key: 'N', text: 'NOIR', priority: 3, active: true },
  { key: 'ISA', text: 'ISABELLE', priority: 0, active: true },
  { key: 'GRT', text: 'GRIS TRUITE', priority: 0, active: true },
  { key: 'GRV', text: 'GRIS VINEUX', priority: 0, active: true },
  { key: 'GFE', text: 'GRIS FER', priority: 0, active: true },
  { key: 'GRR', text: 'GRIS ROUANNE', priority: 0, active: true },
  { key: 'GRF', text: 'GRIS FONCE', priority: 0, active: true },
  { key: 'GR', text: 'GRIS', priority: 4, active: true },
]

export const availableRobes = robes.filter(el => el.active).sort((op1, op2) => op2.priority - op1.priority || op1.text.localeCompare(op2.text))

const mapRobes: Map<string, string> = new Map()
robes.forEach((e) => {
  mapRobes.set(e.key, e.text)
})
export function getRobesLabel(key: string): string | undefined {
  return mapRobes.get(key)
}
